import type { ErrorLike } from '@apollo/client';
import { useQuery } from '@apollo/client/react';
import { type ProjectQuery, ProjectDocument } from 'graphql/generated/graphql';

const useProject = (
  projectId: string,
): [ProjectQuery['project'] | undefined, boolean, ErrorLike | undefined] => {
  const { loading, data, error } = useQuery(ProjectDocument, {
    variables: { id: projectId },
    fetchPolicy: 'cache-and-network',
  });

  return [data?.project, loading, error];
};

export default useProject;
